export default class CheckboxItem {
  public name: string = "";
  public isChecked: boolean = false;
}
